import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate } from 'react-router-dom';
import Login from './login.js';
import Home from './home';
import Reset from './reset';
import './App.css';
import { Helmet } from 'react-helmet';

function isMoreThanAnHourAgo(time) {

  const dateTime = new Date(time);
  
  // Get the current time
  let currentDateTime = new Date();

  // Calculate the difference in milliseconds
  const differenceInMilliseconds =  currentDateTime - dateTime;

  // Convert milliseconds to hours
  const differenceInHours = differenceInMilliseconds / (1000 * 60 * 60);

  // Check if the difference is more than an hour
  return Math.abs(differenceInHours) > 1;
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [username, setUsername] = useState('');
  const [isChange, setChange] = useState(false);
  const usrname = useRef(null);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('token');
    const tokenExpiry = localStorage.getItem('token_expiry');
    const storedUsername = localStorage.getItem('username');
    if (token && !isMoreThanAnHourAgo(tokenExpiry) && storedUsername) {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
      handleLogout();
    }
  };

  const handleLogin = (token, expiry, username, change) => {
    localStorage.setItem('token', token);
    localStorage.setItem('token_expiry', expiry);
    localStorage.setItem('username', username);
    setChange(change);
    setIsAuthenticated(true);
    setUsername(username);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('token_expiry');
    localStorage.removeItem('username');
    setIsAuthenticated(false);
    setUsername('');
  };

  const handleReset = (uname) => {
    usrname.current = uname;
    console.log('test');
    setIsAuthenticated(false);
    setChange(true);
  };
  
  return (
    <Router>
      <div className="App">
      <Helmet>
        <title>index - Salesperf</title>
      </Helmet>
        <Routes>
          <Route path="/" element={
            isAuthenticated ? <Navigate to="/home" replace /> : isChange ? <Navigate to="/reset" replace /> : <Login onLogin={handleLogin} onReset={handleReset} />
          } />
          <Route path="/home" element={
            isAuthenticated ? <Home username={username} onLogout={handleLogout} /> : <Navigate to="/" replace />
          } />
          <Route path="/reset" element={
            !isAuthenticated && isChange ? <Reset username={username} onLogout={handleLogout} /> : <Navigate to="/" replace />
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;